import { useTranslations } from 'next-intl'

import classNames from 'classnames'

import BlockContent from '~/components/atoms/BlockContent/BlockContent'
import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Container, { gutterTypes } from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import { Col, Grid, Row } from '~/components/atoms/Grid'
import { Icon } from '~/components/atoms/Icon/Icon'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'
import { useSettingsContext } from '~/contexts/settingsContext'

import styles from './ContactDetails.module.css'

export interface ContactDetailsProps {
  theme?: ComponentTheme
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  testID?: string
  moduleId?: string
}

export default function ContactDetails({
  testID,
  theme = ComponentTheme.primary,
  verticalPadding,
  noPaddingBottom,
  moduleId,
}: ContactDetailsProps) {
  const { mabAddress, mabAddressUS, pressContactDetails } = useSettingsContext()
  const t = useTranslations('contactDetails')
  return (
    <div className={styles.base} id={moduleId}>
      <Fixture
        theme={theme}
        verticalPadding={verticalPadding}
        noPaddingBottom={noPaddingBottom}
      >
        <Container gutters={gutterTypes.always}>
          <div data-testid={testID} className={styles.wrap}>
            <Grid>
              <Row>
                <Col variant="col-1/2--md">
                  <Text
                    size={TextSizes.primaryTitleMed}
                    Tag="h3"
                    className={styles.sectionTitle}
                  >
                    {t('contactInformation')}
                  </Text>
                  <div className={styles.contactIcon}>
                    <Icon type="Email" width={32} height={32} />
                  </div>
                  <div className={styles.addressContainer}>
                    <BlockContent
                      value={mabAddress}
                      size={TextSizes.bodyLrg}
                    ></BlockContent>
                  </div>
                  {mabAddressUS && (
                    <div
                      className={classNames(
                        styles.mabAddressUS,
                        styles.addressContainer
                      )}
                    >
                      <BlockContent
                        value={mabAddressUS}
                        size={TextSizes.bodyLrg}
                      ></BlockContent>
                    </div>
                  )}
                </Col>
                <Col variant="col-1/2--md" cssClass={styles.col2}>
                  <Text
                    size={TextSizes.primaryTitleMed}
                    Tag="h3"
                    className={styles.sectionTitle}
                  >
                    {t('pressPartnershipsHeading')}
                  </Text>
                  <div className={styles.contactIcon}>
                    <Icon type="MapPin" width={32} height={32} />
                  </div>
                  <Text size={TextSizes.bodyLrg}>
                    <Button
                      variant={ButtonVariants.textLinkLight}
                      link={`mailto:${pressContactDetails?.contact.email}`}
                      className={styles.contactEmail}
                    >
                      {pressContactDetails?.contact.email}
                    </Button>
                  </Text>
                </Col>
              </Row>
            </Grid>
          </div>
        </Container>
      </Fixture>
    </div>
  )
}
